"use strict";
/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a SET_SESSION_PROPERTIES_FILTER request.
 */
var SetSessionPropertiesFilterRequest = /** @class */ (function () {
    /**
     * Create a new SetSessionPropertiesFilterRequest instance
     *
     * @param filter  the filter
     * @param overwriteProperties  the properties to modify
     * @param removeProperties  the properties to remove
     */
    function SetSessionPropertiesFilterRequest(filter, overwriteProperties, removeProperties) {
        this.filter = filter;
        this.overwriteProperties = overwriteProperties;
        this.removeProperties = removeProperties;
    }
    return SetSessionPropertiesFilterRequest;
}());
exports.SetSessionPropertiesFilterRequest = SetSessionPropertiesFilterRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/set-session-properties-filter-request.js
// module id = 1921
// module chunks = 1